/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {ClassValidatorErrors} from './ClassValidatorErrors';

export enum ERROR {
    required = 'required',
    requiredtrue = 'requiredtrue',
    min = 'min',
    max = 'max',
    email = 'email',
    minLength = 'minLength',
    maxLength = 'maxLength',
    pattern = 'pattern',
    dateFormat = 'dateFormat',
    minDate = 'minDate',
    maxDate = 'maxDate',
    isInYear = 'isInYear',
    matDatepickerFilter = 'matDatepickerFilter',
    phone = 'phone',
    ahvNummer = 'ahvNummer',
    integer = 'integer',
    geschlechtAusgewaehlt = 'geschlechtAusgewaehlt',
    invalidXMLZeichen = 'invalidXMLZeichen',
    UNBEKANNT = 'UNBEKANNT',
    NONE = 'NONE',
}

export const ERRORS: { [k in ERROR]: ReadonlyArray<string> } = {
    required: ['required', ClassValidatorErrors.IsNotEmpty, ClassValidatorErrors.IsDefined],
    requiredtrue: ['requiredtrue'],
    min: ['min', ClassValidatorErrors.Min],
    max: ['max', ClassValidatorErrors.Max],
    email: ['email', ClassValidatorErrors.IsEmail],
    minLength: ['minlength', ClassValidatorErrors.MinLength],
    maxLength: ['maxlength', ClassValidatorErrors.MaxLength],
    pattern: ['pattern', ClassValidatorErrors.IsEnum, ClassValidatorErrors.IsUUID],
    dateFormat: ['matDatepickerParse', ClassValidatorErrors.IsDate],
    minDate: ['matDatepickerMin', ClassValidatorErrors.MinDate, ClassValidatorErrors.elohnIsSameOrAfter],
    maxDate: ['matDatepickerMax', ClassValidatorErrors.MaxDate],
    isInYear: ['isInYear', ClassValidatorErrors.IsInYear],
    matDatepickerFilter: ['matDatepickerFilter'],
    phone: [ClassValidatorErrors.IsMobilePhone],
    ahvNummer: [ClassValidatorErrors.elohnAhvNummer],
    integer: [ClassValidatorErrors.IsInt],
    geschlechtAusgewaehlt: [ClassValidatorErrors.elohnGeschlechtAusgewaehlt],
    invalidXMLZeichen: [ClassValidatorErrors.elohnNichtValidXML],
    UNBEKANNT: ['UNBEKANNT'],
    NONE: ['NONE'],
};
